import { useAtomValue } from "jotai";
import { userAtom } from "../../atoms/userAtom";

export function UserName() {
  const user = useAtomValue(userAtom);

  return (
    <div className={"w-full flex flex-col items-end pt-5"}>
      <label className={"text-xl font-bold"}>{user?.displayName}</label>
    </div>
  );
}
